/**
 * Traduções da página inicial
 * Inclui: Conteúdo da página inicial, atualizar arrastando, carregamento de lista
 */
export default {
  randomMatchButton: {
    title: 'Partida Aleatória',
    eachCost: '{cost}/Vez',
  },
}
